// src/utils/orderStatusSync.js
import { collection, query, where, orderBy, onSnapshot, limit } from 'firebase/firestore';
import { db } from '../firebase';

export const watchOrderStatusUpdates = (orderId, onStatusChange) => {
  if (!orderId) return () => {};
  
  console.log(`بدء مراقبة تحديثات الحالة للطلب: ${orderId}`);
  
  // الاستماع للتحديثات من تطبيق الهاتف عبر مجموعة web_notifications
  const webNotificationsRef = collection(db, 'web_notifications');
  const q = query(
    webNotificationsRef,
    where('orderId', '==', orderId),
    orderBy('timestamp', 'desc'),
    limit(1)
  );
  
  return onSnapshot(q, (snapshot) => {
    // التحقق من وجود وثائق جديدة
    if (!snapshot.empty) {
      const latestUpdate = snapshot.docs[0].data();
      console.log(`تم استقبال تحديث حالة من التطبيق:`, latestUpdate);
      
      // تحليل نوع التحديث واستدعاء callback
      if (latestUpdate.action === 'order_picked_up') {
        onStatusChange('تم الاستلام 🚗');
      } else if (latestUpdate.action === 'order_delivered') {
        onStatusChange('تم التسليم ✅');
      }
    }
  }, (error) => {
    console.error('خطأ في مراقبة تحديثات الحالة:', error);
  });
};